import React, { ReactElement, useState } from 'react';
import "./menu.less";
import { Item, ItemProps } from './Item';
import { SubMenu, SubMenuProps } from './SubMenu';

export interface MenuProps {
  items?: ReactElement<ItemProps | SubMenuProps> | ReactElement<ItemProps | SubMenuProps>[];
  children?: ReactElement<ItemProps | SubMenuProps> | ReactElement<ItemProps | SubMenuProps>[];
  mode?: 'vertical' | 'horizontal' | 'inline';
  onClick?: (key: string | number) => void;
}

export const Menu: React.FC<MenuProps> & {
  SubMenu: typeof SubMenu;
  Item: typeof Item;
} = ({ 
  items = [],
  children = [], 
  mode = 'inline',
  onClick 
}) => {
  const [selected, setSelected] = useState<string | number | null>(null);
  const allItems = Array.isArray(items) ? items : [items];
  const allChildren = Array.isArray(children) ? children : [children];
  const allElements = [...allItems, ...allChildren];

  return (
    <div className={`bp2-menu ${mode}-mode`}>
      <ul className="bp2-menu-list">
        {allElements.map(item => {
          if (React.isValidElement(item)) {
            return React.cloneElement(item, { ...item.props, mode, onClick, selected, setSelected });
          }
          return item;
        })}
      </ul>
    </div>
  );
};

Menu.SubMenu = SubMenu;
Menu.Item = Item;

export default Menu;
